import { Component } from "@angular/core";

@Component({
  templateUrl: "./alerts-view.component.html",
})
export class AlertsViewComponent {}
